<template lang="pug">
.TheHeaderMenuNotifications.notification
  .top-bar-user-notifications(
    @click.prevent="setOpenCloseNotificationMenu(true)"
  )
    .notifications-bell(:class="{animated: isRingBell}")
      .not-read(
        v-if="notificationsAllNew > 0",
        :class="{'plus': notificationsCount > 99, 'is-red': isSomeNotificationsWithRedFlag }"
      )
        span {{ notificationsCount > 99 ? '99+' : notificationsCount }}
      SolidBellIcon.svg-icon.bell-icon
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SolidBellIcon from 'images/svg-icons/solid-bell.svg';
import SolidListUlIcon from 'images/svg-icons/solid-list-ul.svg';

export default {
  name: 'TheHeaderMenuNotifications',
  components: {
    SolidBellIcon,
    SolidListUlIcon,
  },
  data() {
    return {
      hovering: false,
      isRingBell: false,
      notificationsCount: 0,
    };
  },
  computed: {
    ...mapGetters('notifications', [
      'notificationsAllNew',
      'isSomeNotificationsWithRedFlag',
    ]),
  },
  watch: {
    notificationsAllNew: {
      handler: 'notificationsUpdateHandler',
      immediate: true,
    },
  },
  methods: {
    ...mapActions('view', [
      'setOpenCloseNotificationMenu',
    ]),
    setCounting() {
      this.notificationsCount = 0;
      const intervalId = setInterval(() => {
        if (this.notificationsCount < this.notificationsAllNew) this.notificationsCount += 1;
        else clearInterval(intervalId);
      }, 60);
    },
    setRingBell() {
      this.isRingBell = true;
      setTimeout(() => {
        this.isRingBell = false;
      }, 1000);
    },
    notificationsUpdateHandler(newVal, oldVal) {
      if (oldVal) {
        this.notificationsCount = this.notificationsAllNew;
      } else {
        this.setCounting();
      }
      if (oldVal < newVal) {
        this.setRingBell();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.notification
  @media screen and (max-width: 991px)
    display: none
.top-bar-user-notifications
  margin-right: 30px
  padding: 20px 0
  position: relative
  cursor: pointer
  ::v-deep .btn-row
    display: none
  .notifications-bell
    position: relative
    line-height: normal
    height: 24px
    &.animated
      .svg-icon
        animation: ring 4s ease infinite
        transform-origin-x: 50%
        transform-origin-y: 0px
        transform-origin-z: initial
    .not-read
      position: absolute
      background-color: $secondary
      top: -4px
      right: -4px
      border-radius: 100px
      border: solid 1px #fff
      z-index: 2
      width: 17px
      height: 17px
      &.plus
        width: 24px
        right: -10px
      &.is-red
        background-color: $support_red
      span
        font-size: 10px
        font-family: $font-medium
        font-weight: 500
        color: $white
        position: absolute
        left: 50%
        top: 50%
        transform: translate(-50%, -50%)
    .svg-icon
      height: sizeInRem(24)
      width: sizeInRem(24)
      fill: $text_gray
      position: relative
@keyframes ring
  0%
    -webkit-transform: rotate(-10deg)
    -ms-transform: rotate(-10deg)
    transform: rotate(-10deg)
  2%
    -webkit-transform: rotate(10deg)
    -ms-transform: rotate(10deg)
    transform: rotate(10deg)
  4%
    -webkit-transform: rotate(-20deg)
    -ms-transform: rotate(-20deg)
    transform: rotate(-20deg)
  8%
    -webkit-transform: rotate(20deg)
    -ms-transform: rotate(20deg)
    transform: rotate(20deg)
  10%
    -webkit-transform: rotate(0deg)
    -ms-transform: rotate(0deg)
    transform: rotate(0deg)
</style>
